<template>
  <section class="obra-content-tabs" aria-label="Conteudo da obra">
    <div class="obra-content-tabs__list" role="tablist">
      <button v-for="tab in tabs" :key="tab.value" type="button" class="obra-content-tabs__tab" :class="{ 'obra-content-tabs__tab--active': activeTab === tab.value }" role="tab" :aria-selected="activeTab === tab.value ? 'true' : 'false'" @click="$emit('change-tab', tab.value)">
        <span>{{ tab.label }}</span>
        <small>{{ tab.count }}</small>
      </button>
    </div>
    <div class="obra-content-tabs__panel" role="tabpanel">
      <slot :name="activeSlot"></slot>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ObraContentTabs',
  props: {
    activeTab: { type: String, default: 'chapters' },
    chaptersCount: { type: Number, default: 0 },
    authorProjectsCount: { type: Number, default: 0 },
    fanartsCount: { type: Number, default: 0 },
  },
  computed: {
    tabs() {
      return [
        { value: 'chapters', label: 'Capitulos', count: this.chaptersCount },
        { value: 'author-projects', label: 'Outras obras do autor', count: this.authorProjectsCount },
        { value: 'fanarts', label: 'Fanartes', count: this.fanartsCount },
      ];
    },
    activeSlot() {
      if (this.activeTab === 'author-projects') return 'authorProjects';
      if (this.activeTab === 'fanarts') return 'fanarts';
      return 'chapters';
    },
  },
};
</script>
